import { render } from "./Customer.vue?vue&type=template&id=417fa0b5&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=417fa0b5&scoped=true&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=417fa0b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417fa0b5"]])

export default __exports__